import { CartService, CartServiceModule } from '@b2b/common/services';
import { UIBModalService } from '@b2b/types/core';
import { TODO } from '@b2b/types/core/utils';
import { OrderContact } from '@b2b/types/order';
import { Organization } from '@b2b/types/organization';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';
import { OrderContactDirectiveModule } from '../order/contact/contact.directive';
import { OrderCouponsDirectiveModule } from '../order/coupons/coupons.directive';
import { OrderOrganizationDirectiveModule } from '../order/organization/organization.directive';
import { OrderSummaryDirectiveModule } from '../order/summary/summary.directive';

function CartDirective() {
  CartDirectiveController.$inject = ['$scope', '$state', '$uibModal', 'OrderService', 'CartService'];

  function CartDirectiveController(
    $scope: IScope & { cart: TODO; showActions: TODO },
    $state: StateService,
    $uibModal: UIBModalService,
    orderService: TODO,
    cartService: CartService,
  ) {
    const scopeCtrl = this;
    scopeCtrl.showCoupons = false;

    const ctrl = {
      model: {},
      summary: {},
      memberships: [] as TODO[],
      events: [] as TODO[],
      coupons: [] as TODO[],
      orderContact: {} as (OrderContact & { membership?: TODO }) | null,
      organization: {} as Partial<Organization> | null,
      cartService: cartService,
      hasItems: false,
      allowEventSales: true,

      tab: 'individual',

      init: function () {
        $scope.$watch('cart.cartService.itemCount', (newValue, oldValue) =>
          ctrl.onCartServiceItemCountUpdate(newValue, oldValue),
        );
        $scope.$watch('cart.cartService.orderContact', () => ctrl.refresh());
        $scope.$watch('cart.cartService.organization', (newValue, oldValue) =>
          ctrl.onCartServiceOrganizationUpdate(newValue, oldValue),
        );
        $scope.$watch('cart.cartService.events.events.length', () => ctrl.refresh());
        $scope.$watch('showCoupons', (newValue, oldValue) => ctrl.setShowCoupon(newValue, oldValue));
        $scope.$watchCollection('cart.cartService.transactingMember', () => ctrl.updateOrderContactMembership());
        $scope.$on('OrderItem::Remove', () => ctrl.refresh());
        //If the selected offer changes for a membership even when orderContact is not updated
        $scope.$watch('cart.cartService.memberships.model', () => ctrl.refresh());
      },

      setShowCoupon: function (newValue, oldValue) {
        scopeCtrl.showCoupons = newValue;
      },

      refresh: function () {
        ctrl.summary = cartService.getSummary();
        ctrl.memberships = cartService.memberships.getModel();
        ctrl.events = cartService.events.getEvents();
        ctrl.orderContact = cartService.getOrderContact();
        ctrl.updateOrderContactMembership();
      },

      updateOrderContactMembership: function () {
        if (ctrl.orderContact) {
          ctrl.orderContact.membership = ctrl.cartService.getTransactingMembership();
        }
      },

      viewCart: function () {
        $state.go('application.cart');
        $scope.$emit('Cart::Close');
      },

      getPricesForEvent: function (event) {
        const eventPrices = event.event && event.event.priceList.prices ? event.event.priceList.prices : [];

        return eventPrices;
      },

      getAddOnsForEvent: function (event) {
        const eventAddOns = event.event && event.event.addOns ? event.event.addOns.inventoryAddOns : [];

        return eventAddOns;
      },

      launchOrganizationOrder: function (e, data) {
        //copy organization, events and quantities to the old organization checkout flow
        //cancel the cart
        const orgOrder = ctrl.cartService.events.getOrganizationOrder();

        orderService.init();
        orderService.clear();
        orderService.store({
          cart: {
            events: orgOrder.events,
          },
        });

        ctrl.cartService.cancelCart();

        $scope.$emit('Cart::Close');

        $state.go('application.orders.checkout', { accountId: orgOrder.organizationId });
      },

      cancel: function () {
        const cancelModal = $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: () => 'Are you sure?',
            okText: () => 'Cancel Order',
            modalMessage: () => 'Do you want to cancel this order?',
          },
        });

        cancelModal.result.then(
          function () {
            $scope.$emit('Cart::Close');
            ctrl.cartService.cancelCart().then(ctrl.success.cancel, ctrl.error.cancel);
          },
          function () {
            // Do nothing
          },
        );
      },

      showTicketsTooltip: function () {
        return !$scope.showActions && ctrl.events.length;
      },

      hasNewMembership: function () {
        return !!ctrl.cartService.memberships.hasNewMembership();
      },

      success: {
        cancel: function (response) {
          ctrl.refresh();
        },
      },

      error: {
        cancel: function (response) {},
      },

      onCartServiceItemCountUpdate: function (n, o) {
        ctrl.hasItems = n;

        if (ctrl.hasItems || n !== o) {
          ctrl.refresh();
        }
      },

      onCartServiceOrganizationUpdate: function (n, o) {
        if (n && n.id) {
          ctrl.tab = 'organization';
          ctrl.organization = cartService.getOrganization();
        }
      },
    };

    $scope.cart = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/cart/cart.tpl.html',
    controllerAs: '$ctrl',
    scope: {
      showActions: '@',
      showCoupons: '<',
      showOrderType: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: CartDirectiveController,
  };
}

export const CartDirectiveModule = angular
  .module('acme.common.directive.cart', [
    CartServiceModule,
    'acme.common.service.order',
    OrderSummaryDirectiveModule,
    OrderContactDirectiveModule,
    OrderCouponsDirectiveModule,
    OrderOrganizationDirectiveModule,
  ])
  .directive('cart', CartDirective).name;
